import { Component, OnInit, Inject, Input, Output, EventEmitter } from 'ng-metadata/core';
import { UserAreaExpandableService } from './userAreaExpandable.service';
import { JwtUtilService } from "../../../security/jwtUtil.service";
import { STATE_NAMES } from '../../../primoExplore/primoExploreStates.module';
import {
    getAuthenticationMethods,
    AuthenticationMethod,
    getVid,
    getBackendSystem,
    getAttributesMap,
    getSummonOverAlma,
    getRapidoSAEnabled, getLimitedPatronsInAlmaStarter, getRequestItEnabled,
} from '../../../appConfig/appConfigForward';
import { JournalsService } from "../../../journals/journals.service";
import { PrimolyticsService, beacon } from '../../../analytics/primolytics.service';
import { LoginIframeService } from "../../../primoExplore/loginIframe.service";
import { LoginService } from "../../../security/login/login.service";
import { UserSessionManagerService } from "../../../security/userSessionManager.service";
import { AuthenticationService } from "./authentication.service";
import { ChangeLangService } from "../../../infra/lang/changeLang.service";
import { OPAC_TYPE, LibraryCardMenuService } from "./libraryCard/libraryCardMenu.service";
import { CMIntegrationService } from '../../../cm_integration.service';
import { ActionListService } from "../../actions/actionList.service";
import { SharedSessionStorage } from "../../../infra/sharedSessionStorage.service";
import { MappingTablesCache } from '../../../mappingTablesCache/mappingTablesCache.service';
import { FavoritesWarningMessageService } from '../../../favorites/favoritesWarningMessage/favoritesWarningMessage.service';
import {ConfigurationUtil} from '../../../nddUtils/configurationUtil.service';
import {AnalyticsUtils} from "../../../nddUtils/analyticsUtils.service";

@Component({
    selector: 'prm-user-area-expandable',
    templateUrl: 'components/search/topbar/userArea/user-area-expandable.html',
})

export class PrmUserAreaExpandable implements OnInit {

    @Input() private isLoggedIn: boolean;
    private view = getVid();
    private FAVORITES_STATE = STATE_NAMES.FAVORITES;
    private spinnerTimedOut: boolean = false;
    private authenticationMethods = getAuthenticationMethods();
    private displayLanguage: boolean = true;
    private languages: string[];
    private attributesMap = getAttributesMap();
    private summonOverAlma = getSummonOverAlma();
    private requestItEnabled = getRequestItEnabled();
    private rapidoSAEnabled = getRapidoSAEnabled();
    private limitedPatronAlmaStarter = getLimitedPatronsInAlmaStarter();
    private signedAlertMessage: string;
    private signOutM: string;
    private signInM: string;
    /*private languages: string[];
     private attributesMap = getAttributesMap();*/
    /*private _selectedLanguage: string;*/
    /*private vid = getVid();*/
    /*private rtlLanguages = getRtlLanguages();*/
    /*@Output() private changeLangEvent: EventEmitter<Object> = new EventEmitter();*/
    private opacType: OPAC_TYPE;
    private lang;
    private showUserArea: boolean = true;
    private DISPLAY_USER_SETTINGS: string = 'display_user_settings';
    @Output() actionEvent = new EventEmitter<void>();
    private KEY_CODE = {
        COMMA: 188,
        SEMICOLON: 186,
        ENTER: 13,
        ESCAPE: 27,
        SPACE: 32,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        END: 35,
        HOME: 36,
        LEFT_ARROW: 37,
        UP_ARROW: 38,
        RIGHT_ARROW: 39,
        DOWN_ARROW: 40,
        TAB: 9,
        BACKSPACE: 8,
        DELETE: 46
    };

    constructor(private userAreaExpandableService: UserAreaExpandableService,
        private configurationUtil: ConfigurationUtil,
        private jwtUtilService: JwtUtilService,
        @Inject('$translate') private $translate: ng.translate.ITranslateService,
        private journalsService: JournalsService,
        private loginIframeService: LoginIframeService,
        private loginService: LoginService,
        private primolyticsService: PrimolyticsService,
        private favoritesWarningMessageService: FavoritesWarningMessageService,
        private userSessionManagerService: UserSessionManagerService,
        private authenticationService: AuthenticationService,
        private changeLangService: ChangeLangService,
        @Inject('$location') private $location,
        @Inject('I18nService') private i18nService,
        @Inject('$state') private $state: ng.ui.IStateService,
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject('$window') private $window: ng.IWindowService,
        private libraryCardMenuService: LibraryCardMenuService,
        @Inject('$mdDialog') private $mdDialog: angular.material.IDialogService,
        @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
        private cmIntegrationService: CMIntegrationService,
        private actionListService: ActionListService,
        private sharedSessionStorage: SharedSessionStorage,
        private mtCache: MappingTablesCache,
                private analyticsUtils: AnalyticsUtils,
    ) {

        this.signOutM = this.$translate.instant('nui.aria.signOutSuccess');
        this.signInM = this.$translate.instant('nui.aria.signInSuccess');

        /*this.languages = this.attributesMap.interfaceLanguageOptions.split(',');*/
        /*this.changeLangService.addLangParamToUrl(this.selectedLanguage);
         this.selectedLanguage = i18nService.getLanguage();*/
        this.opacType = this.libraryCardMenuService.getOpacType();
        this.lang = this.$translate.use();
        this.languages = this.attributesMap.interfaceLanguageOptions.split(",");
        this.displayLanguage = this.languages && this.languages.length > 1;
        if (this.$state.current.name === 'deposit' || this.$state.current.name === 'delivery' || this.$state.current.name === 'canonDelivery' || this.$state.current.name === 'cnameDelivery') {
            this.showUserArea = false;
        }
        if (this.cmIntegrationService.isEnabled()) {
            this.registerMainNavs();
        }
    }

    private registerMainNavs() {
        this.cmIntegrationService.registerMainNavs([{
            code: "LibraryCard",
            label: "nui.menu.librarycard",
            action: this.goToMyLibraryCard.bind(this)
        },
        {
            code: "LibraryCardRequests",
            label: "nui.menu.librarycard",
            action: this.goToRequests.bind(this)
        },
        {
            code: "LibraryCardLoans",
            label: "nui.menu.librarycard",
            action: this.goToLoans.bind(this)
        },
        {
            code: "LibraryCardFines",
            label: "nui.menu.librarycard",
            action: this.goToFines.bind(this)
        },
        {
            code: "LibraryCardMessages",
            label: "nui.menu.librarycard",
            action: this.goToMessages.bind(this)
        },
        {
            code: "LibraryCardPersonalDetails",
            label: "nui.menu.librarycard",
            action: this.goToPersonalDetails.bind(this)
        },
        {
            code: "Favourites",
            label: "eshelf.menu.savedItems",
            action: () => {
                this.goToFavorties();
            }
        },
        {
            code: "SearchHistory",
            label: "eshelf.menu.searchHistory",
            action: () => {
                this.goToSearchHistory();
            }
        }]);
    }

    ngOnInit() {
    }

    getLang() {
        return this.$translate.use();
    }

    get languageCode() {
        return 'mypref.language.option.' + this.lang;
    }

    private isSignedIn() {
        return this.jwtUtilService.isSignedIn();
    }

    public isRapidoSAEnabled(){
        return this.rapidoSAEnabled;
    }

    public isLimitedPatronAlmaStarter(){
        return this.limitedPatronAlmaStarter;
    }

    public isShowUserMenu(){
        return (!this.isDiscoveryLocalNoLogin() && !this.isDiscoveryServicePage() && !this.isDiscoveryWithExternalNoLogin()) ?
            true : this.isRefworksActionEnabled() || this.languages.length > 1;
    }

    public isSummonOverAlma() {
        return this.summonOverAlma;
    }

    public isRequestItEnabled() {
        return this.requestItEnabled;
    }

    public isDiscoveryLocalNoLogin() {
        return this.configurationUtil.getDiscoveryLocalNoLogin();
    }
    public isDiscoveryServicePage() {
        return this.configurationUtil.getDiscoveryServicesPage();
    }

    public isDiscoveryWithExternalNoLogin() {
        return this.configurationUtil.getDiscoveryWithExternalNoLogin();
    }
    
    @beacon({ 'p': 'general', 'op': 'gotoeShelf' })
    goToFavorties() {
        this.$state.go(this.FAVORITES_STATE, this.favoritesStateParams, { reload: true, inherit: false });
    }

    @beacon({ 'p': 'general', 'op': 'gotoSearchHistory' })
    goToSearchHistory() {
        this.$state.go(this.FAVORITES_STATE, this.searchHistoryParams, { reload: true, inherit: false });
    }

    get favoritesStateParams() {
        return { vid: this.view, lang: this.$translate.use(), section: 'items' };
    }

    get searchHistoryParams() {
        return { vid: this.view, lang: this.$translate.use(), section: 'search_history' };
    }

    get uiState() {
        if (this.journalsService.returnToJournalsSearch()) {
            return STATE_NAMES.JOURNAL_SEARCH;
        }
        return STATE_NAMES.SEARCH;
    }

    private showSpinner() {
        if (this.spinnerTimedOut || this.jwtUtilService.backFromLoginIframe) {
            return false;
        }
        if (this.loginIframeService.iframeSilentLoginEnabled && !this.jwtUtilService.backFromLoginIframe) {
            return true;
        }
        return false;
    }

    @beacon({ 'p': 'general', 'op': 'signIn' })
    handleLogin(authentication: AuthenticationMethod) {
        this.loginService.handleLoginClick();
        this.loginService.sendAnalytics('manually');
    }

    @beacon({ 'p': 'general', 'op': 'signOut' })
    handleLogout() {
        this.authenticationService.handleLogout();
        let payload = {
            'Sign Out  Method': 'manually' //Timeout
        }
        this.analyticsUtils.trackUsage(this.analyticsUtils.eventsNames.SIGN_OUT, payload);
    }

    private isLoggedInIDP() {
        if (this.userSessionManagerService.isLoggedInIDP()) {
            return true;
        }
        return this.isLoggedIn;

    }

    public userName() {
        if (getBackendSystem() === 'suprima') {
            return this.userSessionManagerService.getUserNameForDisplay();
        } else {
            return this.userSessionManagerService.getUserName();
        }
    }

    //****** PRM-46520-User settings: persist search history
        public showUserSettingBtn() {
            return this.mtCache.findByProperties(this.mtCache.tables.INSTITUTION_PROPERTIES, { target: 'true', source1: this.DISPLAY_USER_SETTINGS }).length > 0;
        }
    /*private get selectedLanguage() {
     return this._selectedLanguage;
     }
    
     private set selectedLanguage(selectedLanguage) {
     this._selectedLanguage = selectedLanguage;
     }*/

    /*private successAction(response) {
     this.userSessionManagerService.syncJwtWithTabs(response.data);
     this.jwtUtilService.storeJwt(response.data);
     }*/

    /*private changeLanguage(language) {
    
     this.selectedLanguage = language;
    
     this.changeLangService.addLangParamToUrl(this.selectedLanguage);
     if (this.jwtUtilService.getDecodedToken().userGroup !== 'GUEST') {
     let updateUserLanguagePromise = this.changeLangService.updateUserLanguage(this.vid, this.selectedLanguage);
     updateUserLanguagePromise.then((response)=>this.successAction(response));
     }
    
     return this.i18nService.setLanguage(this.selectedLanguage).then(()=> {
     this.changeLangEvent.emit({lang: this.selectedLanguage});
     // the timeout have been added to fix this: PRM-35152
     this.$timeout(()=> {
     return this.$state.go(this.$state.current, {lang: this.selectedLanguage}, {reload: true});
     })
     });
    
     }*/

    /*private setPageLanguage(selectedLanguage) {
     let htmlRoot = <HTMLLinkElement>document.getElementById('primoExploreRoot');
     // since java Locale has a legacy problme wit hthe following code we will replace them manually
     let javaLocaleFixer = {iw: 'he', ji: 'yi', in: 'id'};
     if (htmlRoot && selectedLanguage && selectedLanguage.length >= 2) {
     let code = selectedLanguage.substring(0, 2);
     if (javaLocaleFixer[code]) {
     code = javaLocaleFixer[code];
     }
     htmlRoot.setAttribute('lang', code);
     let direction;
     if (this.rtlLanguages.has(code)) {
     direction = 'rtl';
     }
     else {
     direction = 'ltr';
     }
     this.changeLangService.direction = direction;
     htmlRoot.setAttribute('dir', direction);
    
     }
     }*/

    private currentLang() {
        return this.$translate.use();
    }

    public isOvp() {
        return this.opacType === OPAC_TYPE.OVP;
    }

    /*@beacon({'p': 'general', 'op': 'gotoMyAccount'})*/
    public goToMyLibraryCard() {
        if (this.isOvp()) {
            this.$state.go('account', { vid: getVid(), lang: this.lang, section: 'overview' }, { reload: true });
        } else {
            this.$window.open(this.libraryCardMenuService.getIlsBaseUrl(), '_blank');
        }
        this.actionEvent.emit(null);
    }

    @beacon({ 'p': 'general', 'op': 'gotoMyAccount' })
    public goToUserSettings() {
        this.$state.go('account', { vid: getVid(), lang: this.lang }, { reload: true });
        this.actionEvent.emit(null);
    }

    public goToLoans() {
        this.$state.go('account', { vid: getVid(), lang: this.lang, section: 'loans' }, { reload: true });
    }

    public goToRequests() {
        this.$state.go('account', { vid: getVid(), lang: this.lang, section: 'requests' }, { reload: true });
    }

    public goToFines() {
        this.$state.go('account', { vid: getVid(), lang: this.lang, section: 'fines' }, { reload: true });
    }

    public goToMessages() {
        this.$state.go('account', { vid: getVid(), lang: this.lang, section: 'blocks_messages' }, { reload: true });
    }

    public goToPersonalDetails() {
        this.$state.go('account', { vid: getVid(), lang: this.lang, section: 'personal_details' }, { reload: true });
    }

    public selectedLang(language) {
        let languageCode = 'mypref.language.option.' + language;
        if (this.currentLang() == language) {
            let lang_aria_label = this.$translate.instant(languageCode) + ' ' + this.$translate.instant('nui.aria.menu.selectedLang');
            return lang_aria_label;
        } else {
            return this.$translate.instant(languageCode);
        }
    }

    /*Language selection popup window*/
    public showLoginDialog() {

        /*this.errorMessages = [];
         this.successMessages = [];
    
         /!*  PRM-29824
         *  when personal details is in edit mode and user press on 'Change login credentials' an error should be shown
         *!/
         if (this.formMode !== 'View') {
         this.formMode = 'Error';
         this.errorMessages = ['nui.details.edit.error'];
         return;
         }*/

        let templateString = '' +
            '<md-dialog aria-label="' + this.getLanguageDialogAriaLabel() + '" ' +
            'md-component-id="fullView" ' +
            'style="border-radius: 4px">' +
            '<md-dialog-content>' +
            '<prm-language-selection ' +
            '(on-cancel)="ctrl.onCancel()" ' +
            '(on-save)="ctrl.onSave($event)" ' +
            '</prm-language-selection>' +
            '</md-dialog-content>' +
            '</md-dialog>';

        let _this = this;
        this.$mdDialog.show({
            template: templateString,
            bindToController: true,
            controller: function () {
                //this.passwordSection = _this.passwordSection;
                //this.formData = _this.postData;
                this.onCancel = function () {
                    _this.$mdDialog.hide();
                };
                this.onSave = function (details) {
                    _this.$mdDialog.hide();
                };
                //this.onSave = function(details) {
                //    _this.$mdDialog.hide();
                //    _this.refreshForm({allowEmpty:false, updateValue:true});
                //    _this.successMessages.push(details);
                //    _this.formMode = 'View';
                //};
            },
            controllerAs: 'ctrl'
        });
    }

    public showRequestItBookMarkDialog() {
        let templateString = '' +
            '<md-dialog class="request-it-dialog"' +
            'md-component-id="fullView" ' +
            'style="border-radius: 4px">' +
            '<prm-request-it-bookmark ' +
            '(on-cancel)="ctrl.onCancel()"' +
            '</prm-request-it-bookmark>' +
            '</md-dialog>';

        let _this = this;
        this.$mdDialog.show({
            template: templateString,
            bindToController: true,
            controller: function () {
                this.onCancel = function () {
                    _this.$mdDialog.hide();
                };
            },
            controllerAs: 'ctrl'
        });
    }


    public getLanguageDialogAriaLabel() {
        return this.$translate.instant('nui.aria.userNew.changeLanguage');
    }


    public mainMenuFocusedDialog() {
        this.favoritesWarningMessageService.hideFavoritesWarningForGuestsByMenu();
        this.$timeout(() => {
            let selectorId = this.isSignedIn() ? '#signOutButton' : '#changeLang';
            let element = document.querySelector(selectorId);
            if (element) {
                element.focus();
            }
        }, 100);

    }

    get isOpenMenuDialog() {
        return document.querySelector(".md-active")
    }

    // @HostListener('keydown', ['$event'])
    public keydownSupportSignOut(e) {
        let keyCodes = this.KEY_CODE;

        if (e.keyCode === keyCodes.TAB) {
            e.preventDefault();
            return document.querySelector('#changeLang').focus();
        }

    }

    public keydownSupportSignIn(e) {
        let keyCodes = this.KEY_CODE;

        if (e.keyCode === keyCodes.TAB) {
            e.preventDefault();
            return document.querySelector('#signOutButton').focus();
        }

    }

    private isRTL() {
        return this.changeLangService.direction === 'rtl';
    }

    public isRefworksActionEnabled() {
        return this.actionListService.isActionEnabled('RefWorks');
    }

    @beacon({ 'p': 'general', 'op': 'goToRefworks' })
    public refworksWithBeacon() {
    }

    /*Accessibility message that the user was successfully Signed in/Signed out*/
    public getRoleAlertMessage() {
        if (this.signedAlertMessage) {
            return this.signedAlertMessage;
        }

        const isGuest = this.jwtUtilService.isGuest();

        if (!this.$translate.isReady()) {
            return undefined;
        }

        if (!isGuest) {
            this.signedAlertMessage = this.signInM;
        }
        else if (this.sharedSessionStorage.getItem('userLogStatus') === 'logout') {
            this.sharedSessionStorage.removeItem('userLogStatus');
            this.signedAlertMessage = this.signOutM;
        }

        return this.signedAlertMessage;
    }

    public sendAnalytics( userMenuLinkName : string) {
        let payload = this.getAnalyticsPayload(userMenuLinkName);
        this.analyticsUtils.trackUsage(this.analyticsUtils.eventsNames.USER_MENU_LINKS, payload);
    }

    private getAnalyticsPayload(userMenuLinkName){
        return {
            'User Menu Link Name' : userMenuLinkName
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/topbar/userArea/userAreaExpandable.directive.ts